import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ChevronLeft } from "@parkschannel/ui";
export function AdvancedFiltersNavigationHeader(param) {
    let { onBack , title  } = param;
    return /*#__PURE__*/ _jsxs("header", {
        className: "py-2 flex gap-2 items-center",
        children: [
            /*#__PURE__*/ _jsx("button", {
                onClick: onBack,
                className: "mb-[2px]",
                children: /*#__PURE__*/ _jsx(ChevronLeft, {
                    className: "w-5 h-5 text-neutral-700"
                })
            }),
            title
        ]
    });
}
